var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEyeFull = function SvgEyeFull(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "16px",
    viewBox: "0 0 24 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "31C629F0-F42F-41F2-94E5-5C4A467D75FB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DS_Suez_PCE_Atoms",
    transform: "translate(-130.000000, -675.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets-/-Icons-/-Bold-/-view-1",
    transform: "translate(130.000000, 675.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0.6 C16.4,0.538 20.787,3.614 23.432,6.524 C24.1834044,7.36220507 24.1846963,8.63126683 23.435,9.471 C20.818,12.351 16.494,15.4 12.147,15.4 L12.147,15.4 L11.839,15.4 C7.507,15.4 3.182,12.351 0.568,9.472 C-0.182690534,8.63270247 -0.182690534,7.36329753 0.568,6.524 C3.213,3.615 7.6,0.537 12,0.6 Z M12,3.4 C9.45949015,3.4 7.4,5.45949015 7.4,8 C7.4,10.5405098 9.45949015,12.6 12,12.6 C14.5405098,12.6 16.6,10.5405098 16.6,8 C16.6,5.45949015 14.5405098,3.4 12,3.4 Z M12,6 C13.1045695,6 14,6.8954305 14,8 C14,9.1045695 13.1045695,10 12,10 C10.8954305,10 10,9.1045695 10,8 C10,6.8954305 10.8954305,6 12,6 Z",
    id: "icon-fill-color"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEyeFull);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/eye-full.87cebb56de9916f794ad36dd1aca1b81.svg";